import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { regionConfig } from '@cash-web/shared-region-feature-main'
import { useRegion } from '@cash-web/shared-region-ui-context-main'

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  ${({ theme }) => `
    color: ${theme.arcadeColors.semantic.textSubtle};
    padding: ${theme.spacing.xl} 0;
    margin-top: ${theme.spacing.l};
    border-top: 1px solid ${theme.arcadeColors.semantic.borderDivider};

    ${theme.breakpoints.tablet} {
      flex-direction: row-reverse;
      margin: ${theme.spacing.l} ${theme.spacing.xl} 0;
    }
  `};
`

const FooterLinks = styled.div`
  display: block;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.arcadeColors.semantic.textSubtle};

  a {
    display: inline-block;
    text-decoration: none;

    ${({ theme }) => `
      color: ${theme.arcadeColors.semantic.textStandard};
      margin-right: ${theme.spacing.l};
    `};

    :last-child {
      margin-right: 0;
    }

    :hover {
      text-decoration: underline;
    }
  }
`

export function ErrorFooter() {
  const { t } = useTranslation()
  let regionCode = useRegion()

  const isValidRegion = regionCode && Object.keys(regionConfig).includes(regionCode)

  // if region not present in regionConfig, default to US
  if (!isValidRegion) {
    regionCode = 'US'
  }

  const regionConfigEntry = regionCode ? regionConfig[regionCode] : undefined

  const getFooterText = (key: string) => {
    switch (key) {
      case 'legal':
        return t('Legal', { context: 'legal footer link title' })
      case 'security':
        return t('Security', { context: 'security footer link title' })
      case 'privacy':
        return t('Privacy', { context: 'privacy footer link title' })
      case 'status':
        return t('Status', { context: 'status footer link title' })
      case 'contact':
        return t('Contact', { context: 'contact footer link title' })
      case 'cashApp':
      default:
        return t('Cash App', { context: 'cashApp footer link title' })
    }
  }

  const footerLinks = regionConfigEntry?.footerLinks

  return footerLinks ? (
    <StyledFooter>
      <FooterLinks>
        {footerLinks &&
          Object.keys(footerLinks).map(key => (
            <a href={footerLinks[key as keyof typeof footerLinks]} key={key} target="_blank" rel="noopener noreferrer">
              {getFooterText(key)}
            </a>
          ))}
      </FooterLinks>
    </StyledFooter>
  ) : null
}

export default ErrorFooter
